module.exports = __webpack_public_path__ + "static/media/Flashbang-Rafiki-cards_diamonds-king.4f0dcc2f.svg";